import { DATE_FORMAT } from "helpers/common";
import Badge from "react-bootstrap/Badge";
import React from "react";
import { Link } from "react-router-dom";

const Columns = ({
  onCliclNavigate,
  currentPage,
  pageSize,
  handleViewSummary,
}) => [
  {
    dataField: "",
    text: "SrNo",
    formatter: (cell, row, rowIndex) => (
      <span className="text-capitalize cursor-pointer hover-lightblue">
        {(currentPage - 1) * pageSize + (rowIndex + 1)}
      </span>
    ),
  },
  {
    dataField: "first_name",
    text: "Name",
    formatter: (_, row) => (
      <span
        onClick={() => onCliclNavigate(row?.id)}
        className="text-capitalize cursor-pointer hover-lightblue"
      >
        {row.first_name}
      </span>
    ),
  },
  {
    dataField: "middle_name",
    text: "Middle Name",
    formatter: (_, row) => (
      <span
        onClick={() => onCliclNavigate(row?.id)}
        className="text-capitalize cursor-pointer hover-lightblue"
      >
        {row?.middle_name}
      </span>
    ),
  },
  {
    dataField: "last_name",
    text: "Last Name",
    formatter: (_, row) => (
      <span
        onClick={() => onCliclNavigate(row?.id)}
        className="text-capitalize cursor-pointer hover-lightblue"
      >
        {row?.last_name}
      </span>
    ),
  },
  
  {
    dataField: "email1",
    text: "Email",
    formatter: (_, row) => (
      <span
        onClick={() => onCliclNavigate(row?.id)}
        className="text-capitalize cursor-pointer hover-lightblue"
      >
        {row?.email1 || "--"}
      </span>
    ),
  },

  {
    dataField: "comments",
    text: "Comments",
    formatter: (_, row) => (
      <span
        onClick={() => onCliclNavigate(row?.id)}
        className="text-capitalize cursor-pointer hover-lightblue"
      >
        {row?.comments || "--"}
      </span>
    ),
  },
  {
    dataField: "feedback_id",
    text: "Feedback Id",
    formatter: (_, row) => (
      <span className="text-capitalize cursor-pointer" >{row?.id}</span>
    ),
  },
  {
    text: "Ai Summary",
    dataField: "",
    formatter: (_, row) => (
      <>
        <button
          title="View"
          onClick={(e) => {  e.stopPropagation();handleViewSummary(row)}}
          style={{
            backgroundColor: "transparent",
            border: "none",
            cursor: "pointer",
          }}
        >
          {" "}
          <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <g clip-path="url(#clip0_2_2)">
              <path
                d="M20.7128 7.12798L20.4668 7.69398C20.4284 7.78615 20.3635 7.86488 20.2804 7.92026C20.1973 7.97563 20.0997 8.00518 19.9998 8.00518C19.8999 8.00518 19.8023 7.97563 19.7192 7.92026C19.6361 7.86488 19.5713 7.78615 19.5328 7.69398L19.2868 7.12798C18.8543 6.1267 18.0622 5.3239 17.0668 4.87798L16.3078 4.53898C16.2157 4.49663 16.1377 4.42875 16.083 4.34341C16.0284 4.25807 15.9993 4.15884 15.9993 4.05748C15.9993 3.95613 16.0284 3.8569 16.083 3.77155C16.1377 3.68621 16.2157 3.61834 16.3078 3.57598L17.0248 3.25698C18.0452 2.79836 18.8509 1.96586 19.2758 0.930982L19.5298 0.319982C19.567 0.225336 19.6318 0.14408 19.7158 0.0868075C19.7998 0.0295345 19.8991 -0.00109863 20.0008 -0.00109863C20.1025 -0.00109863 20.2018 0.0295345 20.2858 0.0868075C20.3698 0.14408 20.4346 0.225336 20.4718 0.319982L20.7248 0.929982C21.1493 1.96506 21.9546 2.79792 22.9748 3.25698L23.6928 3.57698C23.7846 3.61946 23.8623 3.68732 23.9168 3.77256C23.9713 3.85779 24.0002 3.95683 24.0002 4.05798C24.0002 4.15914 23.9713 4.25818 23.9168 4.34341C23.8623 4.42864 23.7846 4.4965 23.6928 4.53898L22.9328 4.87698C21.9376 5.32335 21.1459 6.12651 20.7138 7.12798M8.99981 1.99998C10.9425 1.99968 12.8189 2.70629 14.2788 3.98792C15.7388 5.26955 16.6825 7.03863 16.9338 8.96498L19.1838 12.504C19.3318 12.737 19.3018 13.084 18.9588 13.232L16.9998 14.07V17C16.9998 17.5304 16.7891 18.0391 16.414 18.4142C16.0389 18.7893 15.5302 19 14.9998 19H13.0008L12.9998 22H3.99981V18.306C3.99981 17.126 3.56381 16.009 2.75581 15.001C1.81356 13.8245 1.22285 12.4058 1.05173 10.9082C0.880605 9.41068 1.13603 7.89526 1.78858 6.53655C2.44113 5.17783 3.46425 4.03111 4.74008 3.2285C6.0159 2.42588 7.49252 2.00002 8.99981 1.99998ZM21.1538 18.102L19.4888 16.992C20.4764 15.5146 21.0023 13.777 20.9998 12C20.9991 11.4886 20.9578 10.9886 20.8758 10.5L22.8188 9.99998C22.9388 10.65 22.9991 11.3166 22.9998 12C22.9998 14.258 22.3198 16.356 21.1538 18.102Z"
                fill="black"
              />
            </g>
            <defs>
              <clipPath id="clip0_2_2">
                <rect width="24" height="24" fill="white" />
              </clipPath>
            </defs>
          </svg>
        </button>
      </>
    ),
  },
  {
    text: "Created At",
    dataField: "createdAt",
    formatter: (_, row) => DATE_FORMAT(row.createdAt),
  },
  // {
  //   text: "Action",
  //   // dataField: "Inactive",
  //   formatter: (_, row) => (
  //     <>
  //       <button
  //         className="fas fa-pen"
  //         title="Edit"
  //         style={{
  //           backgroundColor: "#fff",
  //           border: "none",
  //         }}
  //         onClick={() => handleEdit(row)}
  //       ></button>
  //       {/* {!row.Inactive ? (
  //         <button
  //           className="fas fa-toggle-on"
  //           style={{
  //             fontSize: "20px",
  //             color: "green",
  //             backgroundColor: "#fff",
  //             border: "none",
  //           }}
  //           title="Active"
  //           onClick={() => handleStatus(row._id, true)}
  //         ></button>
  //       ) : (
  //         <button
  //           className="fas fa-toggle-off"
  //           style={{
  //             fontSize: "20px",
  //             color: "red", 
  //             backgroundColor: "#fff",
  //             border: "none",
  //           }}
  //           title="Inactive"
  //           onClick={() => handleStatus(row._id, false)}
  //         ></button>
  //       )} */}
  //       {
  //         <button
  //           className="fas fa-trash-alt"
  //           style={{
  //             backgroundColor: "#fff",
  //             border: "none",
  //           }}
  //           title="Inactive"
  //           onClick={() => deleteHandler(row._id)}
  //         ></button>
  //       }
  //     </>
  //   ),
  // },
];
export default Columns;
